import { InfoIcon } from 'components/icons';
import PropTypes from 'prop-types';
import styles from 'styles/InfoButton.module.scss';
import { useTranslations } from 'next-intl';
import variables from 'styles/variables.module.scss';

const InfoButton = ({ data, color, children }) => {
    const t = useTranslations('info-button');
    const textBase = t('text-base');

    if (
        data?.toLowerCase() === textBase.toLowerCase() ||
        !data ||
        data === ''
    ) {
        return null;
    }

    return (
        <div className={styles.tooltip}>
            {children || (
                <InfoIcon
                    size={15}
                    color={color || variables.grayLighterColor}
                />
            )}
            <span className={styles.tooltiptext}>{data}</span>
        </div>
    );
};

InfoButton.propTypes = {
    data: PropTypes.string,
    color: PropTypes.string,
    children: PropTypes.element
};
export default InfoButton;
